const DropdownStyle = `
    position: relative;
`;

export default DropdownStyle;
